import { render } from "./PreviewSection.vue?vue&type=template&id=5ecded7e&scoped=true"
import script from "./PreviewSection.vue?vue&type=script&lang=js"
export * from "./PreviewSection.vue?vue&type=script&lang=js"

import "./PreviewSection.vue?vue&type=style&index=0&id=5ecded7e&scoped=true&lang=css"

import exportComponent from "../../../../thejourney/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ecded7e"]])

export default __exports__